module.exports = __webpack_public_path__ + "img/img (52).99f29d29.png";